const {registerModule} = window;

class PostListColumns {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.ui = {};
    this.ui.navigationBar =
      this.element.previousElementSibling &&
      this.element.previousElementSibling.classList.contains('navigationBar') ?
        this.element.previousElementSibling :
        undefined;
    if (
      this.element.classList.contains('post-list-columns--filter-enabled') &&
      this.ui.navigationBar
    ) {
      this.enableFilter();
    }
  }

  // Define the filter method
  filterPosts(tag) {
    const posts = this.element.querySelectorAll('[data-tags]');

    posts.forEach((post) => {
      const tags = post
        .getAttribute('data-tags')
        .split(',')
        .map((t) => t.trim().toLowerCase());

      if (tag.toLowerCase() === 'all' || tags.includes(tag.toLowerCase())) {
        post.style.display = '';
      } else {
        post.style.display = 'none';
      }
    });

    // Update the active class on navigation links
    this.updateActiveNavLink(tag);
  }

  // Method to show all posts
  showAllPosts() {
    const posts = this.element.querySelectorAll('[data-tags]');
    posts.forEach((post) => {
      post.style.display = '';
    });

    // Reset the active class when showing all posts
    this.updateActiveNavLink('all');
  }

  // Method to update the active navigation link
  updateActiveNavLink(tag) {
    // Remove active class from all links
    const navLinks = this.ui.navigationBar.querySelectorAll('a');
    navLinks.forEach((link) => {
      link.parentElement.classList.remove('navigation__list-item--active');
    });

    // Add active class to the matching link
    navLinks.forEach((link) => {
      const linkHash = link.getAttribute('href').split('#')[1];
      if (linkHash && linkHash.toLowerCase() === tag.toLowerCase()) {
        link.parentElement.classList.add('navigation__list-item--active');
      } else if (
        tag.toLowerCase() === 'all' &&
        (!linkHash || linkHash.toLowerCase() === 'all')
      ) {
        link.parentElement.classList.add('navigation__list-item--active');
      }
    });
  }

  enableFilter() {
    // Initialize with current URL hash if present, or default to 'all'
    const currentHash = window.location.hash.substring(1);
    if (currentHash) {
      this.filterPosts(currentHash);
    } else {
      this.showAllPosts();
    }

    // Add click event listeners to navigation links
    const navLinks = this.ui.navigationBar.querySelectorAll('a');
    navLinks.forEach((link) => {
      link.addEventListener('click', () => {
        // Get the hash from the clicked link
        const hash = link.getAttribute('href').split('#')[1];
        if (hash) {
          this.filterPosts(hash);
        } else {
          this.showAllPosts();
        }
      });
    });

    // Handle direct URL changes
    window.addEventListener('hashchange', () => {
      const hash = window.location.hash.substring(1);
      if (hash) {
        this.filterPosts(hash);
      } else {
        // Show all posts if hash is removed
        this.showAllPosts();
      }
    });
  }
}

registerModule('PostListColumns', PostListColumns);
